/**
 * Tiny wrapper around Plausible's custom event API.
 * Safe to call anywhere — no-ops on the server and before the script loads
 * (Plausible's snippet sets up a queue that flushes once loaded).
 *
 * No consent gate needed: Plausible is cookieless and GDPR-compliant.
 *
 * Usage:
 *   trackPlausible("Signup Completed");
 *   trackPlausible("Upgrade Clicked", { plan: "growth" });
 */
export function trackPlausible(
  event: string,
  props?: Record<string, string | number | boolean>,
) {
  if (typeof window === "undefined") return;
  const fn = (window as unknown as {
    plausible?: (event: string, opts?: { props?: Record<string, unknown> }) => void;
  }).plausible;
  try {
    fn?.(event, props ? { props } : undefined);
  } catch {
    /* never break the app for analytics */
  }
}
